module.exports = __webpack_public_path__ + "img/logo_rectangle.1c7d466a.png";